export default "__VITE_ASSET__4c1845b1__"